import React from 'react';
import Alert from '@proofpoint/fuse/components/Alert';
import Collapse from '@mui/material/Collapse'

const Flash = ({severity, message, open, setOpen}) => {
  const closed = {severity:"alert", message:"", open:false};
  if (!message || message.length === 0) {
    return null;
  } 
  return (
    <Collapse in={open} >
      <Alert severity={severity} onClose={()=>{setOpen(closed);}} >
        {message}
      </Alert>
    </Collapse>);
};

export default Flash;
